import { render, staticRenderFns } from "./PersonaTags.vue?vue&type=template&id=010773e0&scoped=true&lang=pug&"
import script from "./PersonaTags.vue?vue&type=script&lang=ts&"
export * from "./PersonaTags.vue?vue&type=script&lang=ts&"
import style0 from "./PersonaTags.vue?vue&type=style&index=0&id=010773e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010773e0",
  null
  
)

component.options.__file = "PersonaTags.vue"
export default component.exports